import * as Yup from 'yup';

export default () => {
  return {
    manager_id: Yup.object().nullable(),
    year: Yup.object().nullable(),
    activity_id: Yup.object().nullable(),
  };
};
